import PropTypes from 'prop-types'

const containerNote = PropTypes.shape({
  categoryId: PropTypes.number,
  cellNumber: PropTypes.string,
  completedAt: PropTypes.string,
  containerNo: PropTypes.string,
  image: PropTypes.shape({
    fullUrl: PropTypes.string,
    thumbnailUrl: PropTypes.string,
  }),
  isComplete: PropTypes.bool,
  loggedAt: PropTypes.string.isRequired,
  remark: PropTypes.string.isRequired,
  updatedAt: PropTypes.string,
})

export default PropTypes.arrayOf(containerNote)
